"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberCell = void 0;
const react_1 = __importDefault(require("react"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const table_styles_1 = require("../table-styles");
function NumberCell({ value }) {
    const classes = table_styles_1.useStyles();
    return react_1.default.createElement(Typography_1.default, { className: classes.tableCell }, value);
}
exports.NumberCell = NumberCell;
NumberCell.displayName = 'NumberCell';
//# sourceMappingURL=number-cell.js.map